import request from "../utils/request";
import qs from 'qs'

//login api
export const loginData = (query) => {
  return request({
    url: "/login",
    method: "post",
    data: query,
  });
};

//AccountManage api
export const SearchRoleData = (token) => {
  return request({
    url: "/role",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};
export const SearchAccountManageData = (token) => {
  return request({
    url: "/user",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};
export const SearchAccountData = (token) => {
  return request({
    url: "/p_home",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};
export const AddAccountManageData = (query, token) => {
  return request({
    url: "/user",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const EditAccountManageData = (query, token) => {
  return request({
    url: "/user",
    method: "put",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const DeleteAccountManageData = (query, token) => {
  return request({
    url: "/user",
    method: "delete",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
//BBS api
export const SearchBBSData = (query) => {
  return request({
    url: "/plcard",
    params: query,
    method: "get",
  });
};
export const SearchBBSDetailData = (query) => {
  return request({
    url: "/plcard/" + query.id,
    method: "get",
  });
};
export const SearchBBSAnswerData = (query) => {
  return request({
    url: "/plcardAnswer",
    params: query,
    method: "get",
  });
};

export const AddBBSData = (query, token) => {
  return request({
    url: "/plcard",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const EditBBSData = (query, token) => {
  return request({
    url: "/plcard",
    method: "put",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const AddBBSAnswerData = (query, token) => {
  return request({
    url: "/plcardAnswer",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

//tintmce

export const tinymceImgUpload = (token, query) => {
  return request({
    url: "/common/upload",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

//PHQuestion api
export const SearchPHQuestionData = (query, token) => {
  return request({
    url: "/p_home/myPlacard",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const SearchBBSTagsData = () => {
  return request({
    url: "/plcard/tags",
    method: "get",
  });
};
export const DeletePHQuestionData = (query, token) => {
  return request({
    url: "/plcard",
    method: "delete",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};

//PHAnswer api
export const SearchPHAnswerData = (query, token) => {
  return request({
    url: "/p_home/myPAnswer",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const SearchBBSAnswerDetailData = (query, token) => {
  return request({
    url: "/plcardAnswer/" + query.id,
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const EditBBSAnswerData = (query, token) => {
  return request({
    url: "/plcardAnswer",
    method: "put",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

export const DeletePHAnswerData = (query, token) => {
  return request({
    url: "/plcardAnswer",
    method: "delete",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};

export const TopBBSAnswerData = (query, token) => {
  return request({
    url: "/plcardAnswer/top",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

export const CancelBBSAnswerData = (query, token) => {
  return request({
    url: "/plcardAnswer/cancelTop",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
//countrylist api
export const SearchCountryListData = (token) => {
  return request({
    url: "/country",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};
//softTypelist api
export const SearchSoftTypeListData = (token) => {
  return request({
    url: "/softType",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};

//version update
export const SearchVersionUpdateData = (token) => {
  return request({
    url: "/softInfo",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};

export const AddVersionUpdateData = (query, token) => {
  return request({
    url: "/softInfo",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

export const EditVersionUpdateData = (query, token) => {
  return request({
    url: "/softInfo",
    method: "put",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

export const DeleteVersionUpdateData = (query, token) => {
  return request({
    url: "/softInfo",
    method: "delete",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};

//SearchLoginInfoData
export const SearchLoginInfoData = (query, token) => {
  return request({
    url: "/loginInfo",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const SearchCountryCodeListData = (token) => {
  return request({
    url: "/loginInfo/countries",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};
export const SearchServicesCodeListData = (token) => {
  return request({
    url: "/loginInfo/services",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};
export const SearchToolTypeListData = (token) => {
  return request({
    url: "loginInfo/toolTypes",
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};
export const SearchTaskDrawerInfoData = (query, token) => {
  return request({
    url: "/taskInfo",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const exportLoginInfoData = (query, token) => {
  return request({
    url: "/loginInfo/downloadLoginInfo",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
//SearchToolsErrorData
export const SearchToolsErrorData = (query, token) => {
  return request({
    url: "/errorInfo",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const AddToolsErrorData = (query, token) => {
  return request({
    url: "/errorInfo",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const EditToolsErrorManageData = (query, token) => {
  return request({
    url: "/errorInfo",
    method: "put",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const DeleteToolsErrorData = (query, token) => {
  return request({
    url: "/errorInfo",
    method: "delete",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
//SearchSystemNoticeData
export const SearchSystemNoticeData = (query, token) => {
  return request({
    url: "/messageInfo",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const AddSystemNoticeData = (query, token) => {
  return request({
    url: "/messageInfo",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const EditSystemNoticeManageData = (query, token) => {
  return request({
    url: "/messageInfo",
    method: "put",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const DeleteSystemNoticeData = (query, token) => {
  return request({
    url: "/messageInfo",
    method: "delete",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
//SearchNormalSettingData
export const SearchNormalSettingData = (query, token) => {
  return request({
    url: "/commoninfo",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const AddNormalSettingData = (query, token) => {
  return request({
    url: "/commoninfo",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const EditNormalSettingManageData = (query, token) => {
  return request({
    url: `/commoninfo`,
    method: "put",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};
export const DeleteNormalSettingData = (query, token) => {
  return request({
    url: "/commoninfo",
    method: "delete",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};

//大文件上传

export const bigFileUploadData = (query, token) => {
  return request({
    url: "/softInfo/uploadFile",
    method: "post",
    data: query,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    },
  });
};

export const bigFileUploadMergeData = (query, token) => {
  return request({
    url: "/softInfo/merge",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

//DateTable
export const getPolygonalDayData = (query, token) => {
  return request({
    url: "/pchart/dailyVisit",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const getPolygonalMonthData = (query, token) => {
  return request({
    url: "/pchart/monthVisit",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const getVisitData = (query, token) => {
  return request({
    url: "/pchart/visitRange",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
export const getHotQuestionTopData = (query, token) => {
  return request({
    url: "/pchart/sortErrorCode",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};
//SearchVersionControlInfoData
export const SearchVersionControlInfoData = (query, token) => {
  return request({
    url: "/project/version/pageQuery",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

export const getPullDownData = (query, token) => {
  return request({
    url: "/project/version/pullDownList",
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};

export const AddProjectVersionData = (query, token) => {
  return request({
    url: "/project/version/addProjectVersion",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

export const DeleteProjectVersionData = (query, token) => {
  return request({
    url: "/project/version/deleteProjectVersion",
    method: "post",
    data: qs.stringify(query),
    headers: {
      Authorization: token,
    },
  });
};

export const UpdateProjectVersionData = (query, token) => {
  return request({
    url: "/project/version/updateProjectVersion",
    method: "post",
    data: query,
    headers: {
      Authorization: token,
    },
  });
};

export const getLatestVersionData = (query, token) => {
  return request({
    url: `/project/version/selectLatestVersion/${query.id}`,
    method: "get",
    headers: {
      Authorization: token,
    },
  });
};

export const updateFlashSwitchData = (query, token) => {
  return request({
    url: `/project/version/flashSwitch`,
    method: "get",
    params: query,
    headers: {
      Authorization: token,
    },
  });
};

export const exportVersionData = (query, token) => {
  return request({
    url: "/project/version/export",
    method: "post",
    data: query,
    headers: {
      Accept: "application/xlsx",
      Authorization: token,
    },
    responseType: 'blob',
  });
};
